"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecentralandEstates = void 0;
var DecentralandEstatesAbi_json_1 = __importDefault(require("./DecentralandEstatesAbi.json"));
exports.DecentralandEstates = DecentralandEstatesAbi_json_1.default;
